import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'
import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import { oidcSettings } from './plugins/oidc'

Vue.use(Vuex)

export const LOADING_MUTATION = 'LOADING_MUTATION'
export const THEME_MUTATION = 'THEME_MUTATION'
export const MESSAGE_ERREUR_MUTATION = 'MESSAGE_ERREUR_MUTATION'

export const TOURNEES_MUTATION = 'TOURNEES_MUTATION'
export const TOURNEES_ACTION = 'TOURNEES_ACTION'
export const CHECK_ELEVEUR_MUTATION = 'CHECK_ELEVEUR_MUTATION'

export const FILTRE_MUTATION = 'FILTRE_MUTATION'

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    oidcStore: vuexOidcCreateStoreModule(oidcSettings)
  },
  /**
  * State
  */
  state: {
    loading: false,
    tournees: [],
    filtre1: '',
    filtre2: '',
    darkTheme: false,
    messageErreur: {
      visible: false,
      message: ''
    },
  },
  /**
   * Mutations
   */
  mutations: {
    /**
     * Loading
     */
    [LOADING_MUTATION](state){
      state.loading = !state.loading
    },
    /**
     * Gestion du theme
     */
    [THEME_MUTATION](state,darkTheme){
      state.darkTheme = darkTheme
    },
    [MESSAGE_ERREUR_MUTATION](state,messageErreur){
      state.messageErreur = messageErreur
    },
    /**
     * Tournees
     */
    [TOURNEES_MUTATION](state,pTournees){
      state.tournees = pTournees
    },
    [CHECK_ELEVEUR_MUTATION](state,payload){
      const { idTournee,idEleveur,checked } = payload
      const index = state.tournees.findIndex(e=>e.id == idTournee)
      if(index != -1){
        const indexEleveur = state.tournees[index].details.findIndex(e=>e.id == idEleveur)
        if(indexEleveur != -1){
          //const detailEleveur = state.tournees[index].details[indexEleveur]
          //state.tournees[index].details[indexEleveur] = {...detailEleveur, eleveurChecked : checked}
          Vue.set(state.tournees[index].details[indexEleveur], 'eleveurChecked' , checked)
        }
      }
    },
    [FILTRE_MUTATION](state,payload){
      const { filtre, value } = payload
      switch (+filtre) {
        case 1: 
          state.filtre1 = value
          break;
        case 2: 
          state.filtre2 = value
          break;
      }
    },
  },
  /**
   * Actions
   */
  actions: {
    /**
     * Récupération des tournées
     */
    async [TOURNEES_ACTION]({ commit, state, dispatch}){
      try {
        commit(LOADING_MUTATION)
        const res = await axios.get('api/tournee', {
          headers: {
            'Authorization': `Bearer ${state.oidcStore.access_token}`
          }
        })
        const { data } = res
        commit(TOURNEES_MUTATION,data)
      } catch (error) {
        const { request } = error
        // si on est pas authorisé alors on redirige vers l'authentification
        if (request && request.status === 401) {
          dispatch('authenticateOidc','/')
        } else {
          commit(MESSAGE_ERREUR_MUTATION, {
            visible: true,
            message: `Impossible de récupérer les tournées`
          })
        }
      } finally {
        commit(LOADING_MUTATION)
      }
    }
  },
  /**
   * Getters
   */
  getters: {
    filteredTournee(state){
      return state.tournees.filter(e => {
        if(state.filtre1 != '' && state.filtre2 != ''){
          return e.critere1 == state.filtre1 && e.critere2 == state.filtre2
        }else if(state.filtre1 != ''){
          return e.critere1 == state.filtre1
        }else if(state.filtre2 != ''){
          return e.critere2 == state.filtre2
        }else{
          return true
        }
      })
    },
    selectedTournee: (state) => (id) => state.tournees.find(tournee => tournee.id == id),
    tourneeFiltre1: (state) => {
      return state.tournees.reduce((tabRes,el) => {
        if(tabRes.findIndex(e=>e==el.critere1) == -1 && el.critere1.trim() != '') tabRes.push(el.critere1)
        return tabRes
      },[''])
    },
    tourneeFiltre2: (state) => {
      return state.tournees.reduce((tabRes,el) => {
        if(tabRes.findIndex(e=>e==el.critere2) == -1 && el.critere2.trim() != '') tabRes.push(el.critere2)
        return tabRes
      },[''])
    }
  }
})
